import React from "react";
import { useQuickSightBedrock } from "@/hooks/useBedrockReports";

const QuickSightAwsBedrockDashboard = () => {
  const { embedUrl } = useQuickSightBedrock ();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAwsBedrockDashboard;
